import { Avatar } from '@mantine/core';

import classes from './Avatar.module.css';

const AvatarDefaults = Avatar.extend({
  defaultProps: {
    radius: '50%',
  },
  classNames: {
    root: classes.root,
    placeholder: classes.placeholder,
  },
});

export { Avatar, AvatarDefaults };
